import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SecurityService } from '../../../security/security.service';
import { HomeService } from '../../services/home.service';
import { delay, takeUntil } from 'rxjs/operators';
import { Module } from '../../modules/response.model';
import { Observable, Subject, Subscription } from 'rxjs';
import { MatIcon } from '@angular/material/icon';
import { eventTypes } from 'src/app/shared/models/event.model';
import { EventCollectorService } from 'src/app/shared/services/event-collector.service';
import {Store} from "@ngrx/store";
import {AppState} from "../../../store/app.reducer";
import {AuthStorage, Business, DesignProject, NewUser, OperationTypes} from "../../../auth/models/login.model";
import {logOut, setClients, setDesingProjects} from "../../../store/auth/auth.actions";
import {LoginService} from "../../../auth/services/login.service";
import {unsetProject} from "../../../store/project/project.actions";
import { selectLogo, selectProjectConfiguration } from 'src/app/store/project/project.selectors';
import { Generic } from 'src/app/utils/generic';
import { RouterService } from 'src/app/shared/services/router.service';
import { InfoModalV2Service } from 'src/app/shared/services/modals/info-modal-v2.service';
import { TypeModalEnum } from 'src/app/shared/models/modals/info-modal-v2.model';
import { MatDialog } from '@angular/material/dialog';

@Component({
	selector: 'app-container',
	templateUrl: './container.component.html',
	styleUrls: ['./container.component.css'],
	standalone: false
})
export class ContainerComponent implements OnInit, OnDestroy {

	isHover: boolean = false;
	optionSelected: Module;
	inSubMenu = false;
	inIconMenu = false;
	eventCollectorObj: any = {
		2: ['click_crearYAsignarDiseñaTuAccionOExamen', 'Crear y Asignar'],
		3: ['click_crearYAsignarProgramaTuAccion', 'Crear y Asignar'],
		4: ['click_crearYAsignarMisiones', 'Crear y Asignar'],
		5: ['click_crearYAsignarMisionesAsignacionMasiva', 'Crear y Asignar'],
		6: ['click_crearYAsignarComunicados', 'Crear y Asignar'],
		7: ['click_crearYAsignarSecciones', 'Crear y Asignar'],
		26: ['click_crearYAsignarCursos', 'Crear y Asignar'],
		9: ['click_reportesCheckInCheckOut', 'Reportes'],
		10: ['click_reportesAcciones', 'Reportes'],
		11: ['click_reportesMisiones', 'Reportes'],
		12: ['click_reportesComunicados', 'Reportes'],
		13: ['click_reportesSellosDigitales', 'Reportes'],
		14: ['click_reportesFacturasPago', 'Reportes'],
		15: ['click_reportesRetenciones', 'Reportes'],
		16: ['click_reportesInfomacionDeTrader', 'Reportes'],
		17: ['click_reportesAvanceDeVentas', 'Reportes'],
		27: ['click_reportesCursos', 'Reportes'],
		19: ['click_pagarATradersOrdenDePago', 'Pagar a Traders'],
		20: ['click_pagarATradersDispersarConciliar', 'Pagar a Traders'],
		21: ['click_pagarATradersRetenciones', 'Pagar a Traders'],
		23: ['click_configuracionGestionDeModulos', 'Configuración'],
		24: ['click_gestionDeUsuarios', 'Gestión de Usuarios'],
		25: ['click_avanceDeVentas', 'Avance de Ventas'],
	};
	newUser: NewUser; // NEW LOGIN
	operationType: OperationTypes;
	clients: Business[] = [];
	projectSelected: boolean = false;
	allClients: boolean = false;
	@ViewChild('menuOptionsDiv') menuOptionsDiv: ElementRef<HTMLDivElement>;
	@ViewChild('menuOptionIcon') menuOptionIcon: MatIcon;
	menuOptions: Module[] = [];

	closeSubject = new Subject<void>();
	destroy$ = new Subject<void>();
	subsUnsuscribe: Subscription;
	stopSubOperation: Subscription;
	interval: NodeJS.Timeout;
	logo: string = '';
	notShownAllClient = [38, 18, 22, 34];
	logoProject = '';
	color = '';
	designProject: DesignProject[] = [];

	constructor(
		private router: Router,
		private loader: NgxSpinnerService,
		private security: SecurityService,
		private modal: InfoModalV2Service,
		private homeService: HomeService,
		private loginService: LoginService,
		private eventCollector: EventCollectorService,
		private store: Store<AppState>,
		private routerService: RouterService,
		private dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.store.select('auth').pipe(takeUntil(this.destroy$)).subscribe( async (auth) => {
			if (!auth.user) return;
			this.newUser = auth.user!;
			this.designProject = auth.designProjects;
			if (auth.clients.length === 0) {
				this.getClients(this.newUser.idUser);
			} else {
				this.clients = auth.clients;
			}
		})
		this.store.select(selectProjectConfiguration).pipe(takeUntil(this.destroy$)).subscribe(project => {
			this.projectSelected = project.projectId > -1;
			this.allClients = project.allClient;
			if (this.allClients) {
				this.menuOptions = this.menuOptions.filter(m => !this.notShownAllClient.includes(m.moduleId));
			} else {
				let menu = localStorage.getItem('modules');
				if (menu && (atob(menu) != '' || atob(menu) != '[]')) {
					this.menuOptions = JSON.parse(atob(menu));
				} 
			}
			this.logoProject = project.logoProject || 'assets/logo.svg';
			this.logo = project.logo || 'assets/profile-image.jpg';
			const navBar = document.querySelector('mat-sidenav .mat-drawer-inner-container') as HTMLDivElement;
			navBar.style.backgroundColor = project.color || 'var(--color)';
			this.color = project.color;
			if (project.color) {
				this.setThema('project-theme', 'trader-theme');
			} else {
				this.setThema('trader-theme', 'project-theme');
			}
		})
		this.interval = setInterval(() => this.checkModules(), 300000);
		this.stopSubOperation = this.homeService.updateOperation.subscribe(async () => {
			this.loader.show();
			await this.getClients(this.newUser.idUser, false);
			await this.getInfoDesigns()
			this.loader.hide();
		});
		let menu = localStorage.getItem('modules');
		if (menu && (atob(menu) != '' || atob(menu) != '[]')) {
			this.menuOptions = JSON.parse(atob(menu));
			if (this.allClients) {
				this.menuOptions = this.menuOptions.filter(m => !this.notShownAllClient.includes(m.moduleId));
			}
		} else {
			this.getNewMenu();
		}
		this.subsUnsuscribe = this.closeSubject
			.pipe(delay(1000))
			.subscribe((value) => {
				if (!this.inSubMenu && !this.inIconMenu) {
					this.closeSubMenu();
				}
			});
	}

	async checkModules () {
		const menu = await this.getNewMenu(false);
		const menuString = JSON.stringify(menu);
		const menuSaved = atob(localStorage.getItem('modules') || '');
		if (menu.length === 0) {
			await this.modal.openInfoModal({title: '¡Ups!', text: 'Este perfil no cuenta con un rol. Contacta a soporte para habilitar los modúlos.', type: TypeModalEnum.WARNING, cancelButton: false})
			this.logout();
		}
		if (menuString !== menuSaved) {
			await this.modal.openInfoModal({title: '¡Ups!', text: 'Tu perfil tuvo cambios es necesario que inicies sesión nuevamente de clic en aceptar.', type: TypeModalEnum.WARNING, cancelButton: false})
			this.logout();
		}
	}

	eventSelected(m: Module) {
		if (!this.projectSelected) {
			return;
		}
		const pageSelected = this.eventCollectorObj[m.moduleId]
			? this.eventCollectorObj[m.moduleId]
			: '';
		if (pageSelected != '') {
			this.eventCollector.event({
				type: eventTypes.click,
				module: pageSelected[1],
				class: 'ContainerComponent',
				method: 'eventSelected()',
				data: '',
				name: pageSelected[0],
			});
		}
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
		this.subsUnsuscribe.unsubscribe();
		this.stopSubOperation?.unsubscribe();
		clearInterval(this.interval);
		localStorage.clear();
	}

	async getNewMenu (loader = true): Promise<Module[]> {
		try {
			if (loader) {
				this.loader.show();
			}
			const menuResponse: any = await this.homeService.getNewMenu(this.newUser.idUser);
			const decryptedResponse = await this.security.decrypt({data: menuResponse.data});
			if (loader) {
				this.loader.hide();
			}
			if (decryptedResponse.body.data.success) {
				const response = decryptedResponse.body.data.items[0].modules || []
				if (loader && response.length === 0) {
					await this.modal.openInfoModal({title: '¡Ups!', text: 'Este perfil no cuenta con un rol. Contacta a soporte para habilitar los modúlos.', type: TypeModalEnum.WARNING, cancelButton: false});
					this.logout();
					return [];
				}
				const menu = response.map((item: any) => {
					return {
						...item,
						parent: item.modules.length > 0
					}
				});
				if (loader) {
					this.menuOptions = menu;
					const modulesRoute = Generic.flat(this.menuOptions, 'modules').filter(item => item.route !== '').map(item => item.route.split('/').slice(0, 3).join('/'));
					localStorage.setItem('modules', btoa(JSON.stringify(this.menuOptions)));
					localStorage.setItem('routes', btoa(JSON.stringify([...new Set(modulesRoute)])));
				}
				return menu;
			} else {
				if (decryptedResponse.body.data.message.id === 19) {
					await this.modal.openInfoModal({title: '¡Ups!', text: 'Este perfil no cuenta con un rol. Contacta a soporte para habilitar los modúlos.', type: TypeModalEnum.WARNING, cancelButton: false});
					this.logout();
				} else {
					this.infoModal(
						'Permisos no disponibles',
						'No se pudo obtener los permisos del menú.',
						TypeModalEnum.WARNING
					);
				}
				return [];
			}
		} catch (e) {
			this.loader.hide();
			this.modal.openGenericInfo();
			return [];
		}
	}

	async getClients (userId: number, loader = true): Promise<void> {
		try {
			if (loader) {
				this.loader.show();
			}
			const encryptedResponse: any = await this.loginService.getOperationTypes(userId);
			const decryptedResponse = await this.security.decrypt({data: encryptedResponse.data});
			if (loader) {
				this.loader.hide();
			}
			if (decryptedResponse.body.data.success) {
				const clients: Business[] = decryptedResponse.body.data.items[0].operationTypes[0].businessList;
				this.clients = clients;
				this.store.dispatch(setClients({clients}));
				localStorage.setItem('clients', btoa(JSON.stringify(clients)));
			} else {
				this.modal.openGenericInfo();
			}
		} catch (e) {
			this.loader.hide();
			this.modal.openGenericInfo();
		}
	}

	navigate (module: Module) {
		if (!this.projectSelected && !this.allClients) { return; }
		if (!module.route) return;
		if (this.router.url.includes('users/register')) {
			this.routerService.existOfModule.next(module.route);
			return;
		}
		this.router.navigate([module.route]);
	}

	setThema(t: string, remove: string) {
		document.documentElement.classList.remove(remove);
    document.documentElement.classList.add(t);
  }

	logout() {
		localStorage.clear();
		this.dialog.closeAll();
		this.store.dispatch(logOut());
		this.store.dispatch(unsetProject());
		this.router.navigate(['/auth/login']);
	}

	infoModal(title: string, text: string, type: TypeModalEnum) {
		this.modal.openInfoModal({
			title: title,
			text: text,
			type: type,
			cancelButton: false,
		});
	}

	isOnHover(option: Module) {
		if (!option.parent || (this.newUser && !this.projectSelected && !this.allClients)) {
			return;
		}
		this.optionSelected = option;
		this.isHover = true;
		this.inIconMenu = true;
		const div = document.getElementById(`link-${option.moduleId}`)!;
		const { top, height } = div.getBoundingClientRect();
		let newHeight;
		if (this.optionSelected.modules.length > 4) {
			newHeight = height / 2;
		} else {
			newHeight = 0;
		}
		this.menuOptionsDiv.nativeElement.style.top = top - newHeight + 'px';
		this.menuOptionsDiv.nativeElement.style.display = 'flex';
		this.menuOptionIcon._elementRef.nativeElement.style.top = top + 10 + 'px';
		this.menuOptionIcon._elementRef.nativeElement.style.display = 'initial';
		this.closeMenu();
	}

	closeMenu() {
		this.closeSubject.next();
	}

	closeSubMenu() {
		this.isHover = false;
		this.menuOptionsDiv.nativeElement.style.display = 'none';
		this.menuOptionIcon._elementRef.nativeElement.style.display = 'none';
		this.inSubMenu = false;
		this.inIconMenu = false;
	}

	clearLocalStorage(m: any) {
		if (m.moduleId == 19) {
			localStorage.removeItem('company');
			location.hash == '#' + m.route && location.reload();
		}
	}

	async getInfoDesigns () {
    try {
      const encryptedResponse: any = await this.loginService.infoMail(this.newUser.mail);
      const decryptedResponse = await this.security.decrypt({data: encryptedResponse.data});
      if (decryptedResponse.body.data.success) {
        this.store.dispatch(setDesingProjects({designs:decryptedResponse.body.data.items}));
				const info: AuthStorage = {
					user: this.newUser,
					clients: this.clients,
					designProjects: decryptedResponse.body.data.items
				}
				localStorage.setItem('auth', btoa(JSON.stringify(info)));
      } else {
        this.modal.openInfoModal({title: 'Error', text: 'Hubo un error al cargar la configuración de los proyectos', type: TypeModalEnum.ERROR, cancelButton: false});
      }
    } catch (error) {
      this.loader.hide();
      this.modal.openGenericInfo();
    }
  }
}
